<div class="h-full flex flex-col justify-between">
    <div class="detail panel-content">
        <div class="header">
            <app-title
                class="header-title font-medium text-2xl"
                [title]="depositWithFolderAndStandardBloc.value()?.depositFolder?.name ?? ''"
                (goToPreviousPage)="closeDetail()" />
        </div>
        <div class="content px-9">
            <div class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-3 my-8">
                <div class="flex flex-col">
                    <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                        {{ 'name' | transloco }}
                    </p>
                    <p class="!m-0">{{ depositWithFolderAndStandardBloc.value()?.name }}</p>
                </div>
            </div>
            <div class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-3 my-8">
                <div class="flex flex-col">
                    <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                        {{ 'version' | transloco }}
                    </p>
                    <p class="!m-0">{{ depositWithFolderAndStandardBloc.value()?.version }}</p>
                </div>
            </div>
            @if (layerListBloc.value()?.items) {
                <div class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-3 my-8">
                    <div class="flex flex-col">
                        <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                            {{ 'layers' | transloco }}
                        </p>
                        <div class="flex flex-col items-start gap-4">
                            <div class="grid grid-cols-2 gap-x-4">
                                @for (layer of layerListBloc.value()!.items; track layer.id) {
                                    <span
                                        class="flex flex-row gap-1 min-w-40"
                                        [class]="`col-start-${($index % 2) + 1}`">
                                        @if (!layer.hasGeom) {
                                            <fa-icon
                                                size="xs"
                                                [icon]="['far', 'table-cells']"
                                                [matTooltip]="'attributeLayers' | transloco: { COUNT: 1 }" />
                                        }
                                        <p class="!m-0">{{ layer.name }}</p>
                                    </span>
                                } @empty {
                                    <p class="!m-0">{{ 'noLayers' | transloco }}</p>
                                }
                            </div>

                            <app-paginator
                                [take]="layerListBloc.value()!.take"
                                [totalItems]="layerListBloc.value()!.totalItems"
                                (onPageChange)="onPaginationChange($event)" />
                        </div>
                    </div>
                </div>
            }
        </div>

        @if (metadataInformation()) {
            <app-deposit-metadata-information [metadataInformation]="metadataInformation()!" />
        }
    </div>
</div>
